<template>
    <div>
        <div class="row align-items-center">
            <form-field ref="descricao" v-model="pdtipo.descricao" type="text" col="6" :metadata="metadata.pdtipo.descricao" 
                name="descricao" :v-errors="errors" v-validate="metadata.pdtipo.descricao.validator"></form-field>
            <div class="col-md-4 col-6">
                <v-button label="Salvar" :nb-btdef="true" @click="handleSave"></v-button>
                <v-button label="Cancelar" @click="closeForm"></v-button>
            </div>
        </div>
    </div>
</template>

<script>

import { SysVars } from '../main'
import { apiORDSpost, apiORDSdelete } from '../shared/api-functions'

export default {
    props: {
        index: '',
        crud: '',
    },

    data() {
        return {
            crudText: '',
            pdtipo: {...this.$store.getters.getEntities.pdtipo},
            metadata: this.$store.getters.getEntities.metadata,
            errmessages: [],  //armazena as mensagens de validacao do servidor para mostrar em tela
        }
    },

    computed: {
        editing: function () {
            return this.crud == SysVars.crudU
        }

    },

    methods: {
        closeForm () {
            this.$emit('closeform', this.pdtipo.codtipo)
        },

        handleSave () {
            //BOTAO SALVAR
            this.$validator.validateAll().then(isValid => {
                if (!isValid) {
                    this.$erpToastError('Por favor, corrija os campos em destaque para continuar')
                } else {
                    this.apiPost()
                }
            })
        },

        async loadData () {
            //carrega o registro para alteracao ou visualizacao
            await this.$store.dispatch('loadPdtipo', { id: this.index } )
            if (this.$store.getters.getPdtipo) {
                this.pdtipo = {...this.$store.getters.getPdtipo}
            }  
            this.$nextTick(function () {
                jQuery('[data-toggle="tooltip"]').tooltip()
            })
        },

        async apiPost () {
            //efetua a gravacao

            var modulo = 'cg/pdtipo/'
            var sendData = {}

            sendData = { pdtipo: this.pdtipo }

            let metodo = 'post'
            let update = false
            if (this.crud != SysVars.crudI) {
                update = true
            }
            const data = await apiORDSpost(this.$store, modulo, sendData, metodo)
            if (data.errmessages) {
              this.errmessages = data.errmessages
              this.$erpToastError('Alguns erros precisam ser corrigidos.')
            } else {
                if (update) {
                    this.$erpToastUpdated()
                } else {
                    this.$erpToastInserted()
                }
                this.errmessages = {}
                this.closeForm()
            }
        },
        
    },

    components: {

    },

    beforeCreate () {

    },

    created () {
        this.crudText = this.$crudText(this.crud)

        if (this.crud == SysVars.crudI) {
        } else {
            this.loadData()  
        }
        this.$nextTick(function () {
            jQuery('[data-toggle="tooltip"]').tooltip()
            this.$refs.descricao.focus()
        })
    }

}

</script>

<style>

</style>



// WEBPACK FOOTER //
// src/forms/pdtipo-form.vue